import React from 'react';
import { withRouter } from 'react-router-dom';

// Components
import SingleFormLayout from '../../_layout/SingleFormLayout/single-form.layout';
import RegisterCompanyFormContainer from '../../../Company/RegisterCompanyForm/register-company-form.container';
import { SignedInRedirect } from '../../../_core/SignedInRedirect/signed-in-redirect.component';
import { SessionType } from '../../../../lib/types/session.types';

interface RegisterPageProps {
  location: any;
}

const RegisterPageContainer: React.FC<RegisterPageProps> = ({ location }) => (
  <SignedInRedirect tree={SessionType.STAFF}>
    <SingleFormLayout maxWidth="600px">
      <RegisterCompanyFormContainer />
    </SingleFormLayout>
  </SignedInRedirect>
);

export default withRouter(RegisterPageContainer);
